import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { PayWay, payWayList } from "@/utils/contants";
import { message } from "antd";
import successImg from "@/assets/svg/success.svg";
import { computedArticleTaxMoney, IS_MOBILE } from "@/utils/tool";
import { formatOriginalAmount } from "@/utils/currency";
import "./mobile.feedetail.scss";
type Props = {
  order: Pick<
    Order,
    | "total_money"
    | "exp_cny_pay_money"
    | "tax_money"
    | "commission_money"
    | "currency"
    | "raw_exp_money"
    | "pay_methods"
    | "pay_status"
    | "order_id"
    | "configuration"
  >;
  way: PayWay;
  setWay: (way) => void;
  bill: (InvoiceInfo & InvoiceAddress) | null;
  mergeOrderSelectIds: Array<string>;
  moneyList: Array<number>;
};
import { useRecoilValue } from "recoil";
import { buyJournalMoneySelector, isBuyJournalSelector } from "@/store/order";
import { math } from "@/utils/math";

const FeeDetail = (props: Props) => {
  const { order, way, setWay, mergeOrderSelectIds } = props;
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const payList = useMemo(() => {
    return order.pay_methods;
  }, [order]);

  //   const shouPublic = useMemo(() => {
  //     return order.pay_methods.includes(PayWay.Offline);
  //   }, [order]);
  const checkedBuyStore = useRecoilValue(isBuyJournalSelector);
  const buyMoneyStore = useRecoilValue(buyJournalMoneySelector);
  const buyJournalInfo = useMemo(() => {
    if (buyMoneyStore) {
      const tax_money = computedArticleTaxMoney(buyMoneyStore);
      return {
        buyPrice: buyMoneyStore,
        tax_money,
      };
    }
    return {
      buyPrice: 0,
      tax_money: 0,
    };
  }, [buyMoneyStore]);

  /**
   * 计算金额
   */
  const totalPrice = useMemo(() => {
    if (!checkedBuyStore) return order.total_money.toFixed(2);
    return math.add(order.total_money, buyMoneyStore).toFixed(2);
  }, [order, checkedBuyStore, buyMoneyStore]);

  const showApcAmount = order.configuration.show_tax_money && checkedBuyStore;
  const showOriginalCurrency =
    order.configuration.show_original_currency &&
    mergeOrderSelectIds.length === 0;
  const showCommission = order.configuration.show_commission_money;
  const showTax = order.configuration.show_tax_money;
  const showApcSection =
    showApcAmount || showOriginalCurrency || showCommission || showTax;
  const showPaperSection = showTax && checkedBuyStore;

  return (
    <>
      {contextHolder}
      <div className={`fee-detail ${IS_MOBILE && "mobile-fee-detail"}`}>
        <div className="fee-info">
          <div className="info-money">
            <div className="mark">{t("需支付金额")}</div>
            <div className="price">
              <span>¥</span>
              <span>{totalPrice}</span>
            </div>
          </div>
          {(showApcSection || showPaperSection) && (
            <div className="fee-divider" />
          )}
          {showApcSection && (
            <div className="paper-price-box apc-price-box">
              {showApcAmount && (
                <div className="info-item info-item-primary">
                  <span>APC</span>
                  <span>¥{order.total_money.toFixed(2)}</span>
                </div>
              )}
              {showOriginalCurrency && (
                <div className="original-currency">
                  {t("APC外币价（不含税费）")}{" "}
                  {formatOriginalAmount(order.currency, order.raw_exp_money)}
                </div>
              )}
              {showCommission && (
                <div className="info-item info-item-muted info-item-sub">
                  <span>{t("服务费")}</span>
                  <span>¥{order.commission_money.toFixed(2)}</span>
                </div>
              )}
              {showTax && (
                <div className="info-item info-item-muted info-item-sub">
                  <span>{t("增值税")}</span>
                  <span>¥{order.tax_money.toFixed(2)}</span>
                </div>
              )}
            </div>
          )}
          {showPaperSection && (
            <div className="paper-price-box">
              <div className="info-item info-item-primary">
                <span>{t("纸本期刊")}</span>
                <span>¥{buyJournalInfo.buyPrice?.toFixed(2)}</span>
              </div>
              <div className="info-item info-item-muted">
                <span>{t("纸本期刊增值税")}</span>
                <span>¥{buyJournalInfo.tax_money?.toFixed(2)}</span>
              </div>
            </div>
          )}
        </div>

        {order.pay_status !== 2 && (
          <div
            className="way-box"
            style={IS_MOBILE ? { paddingLeft: 12, paddingRight: 12 } : {}}
          >
            <div
              className="way-title"
              style={IS_MOBILE ? { marginTop: 0 } : {}}
            >
              <span>{t("支付方式")}</span>
            </div>
            <div
              className="pay-list"
              style={
                payList.length == 2
                  ? { justifyContent: "flex-start", columnGap: "20px" }
                  : {}
              }
            >
              {payList.map((_way) => {
                const payWay = payWayList[_way];
                if (!payWay) return null;
                return (
                  <span
                    key={_way}
                    className={way === _way ? "pay-selected" : ""}
                    onClick={() => {
                      setWay(_way);
                    }}
                    style={payList.length == 2 ? { flex: 1 } : {}}
                  >
                    {way === _way && (
                      <img className="success-icon" src={successImg} alt="" />
                    )}
                    <img className="pay-icon" src={payWay.src} alt="" />
                    <span className="pay-label">{t(payWay.value)}</span>
                  </span>
                );
              })}
            </div>
            <div className="pay-tip">
              {t("公务卡支付请选择信用卡/借记卡支付")}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

/**
 * apc 订单信息
 * @returns
 */
const ApcBuyInfo = () => {
  return <div></div>;
};

export default FeeDetail;
